class BeforeAfter {
  constructor() {
    const beforeAfterModule =
      document.getElementsByClassName("before-after")[0];
    if (beforeAfterModule) {
      this.init();
    }
  }

  /* eslint-disable */
  init() {
    window.loadJS(
      "/wp-content/themes/sutega/js/vendor/pixelcompare.js",
      () => {}
    );
  }
  /* eslint-enable */
}

export default BeforeAfter;
